module.exports = __webpack_public_path__ + "static/media/docs (5).9f146a48.webp";